import axios from 'axios'

const api = async (method, url, payload, isDownload = false) => {
	try {
		let response

		if (method === 'get') {
			response = await axios.get(url)
		} else if (method === 'post') {
			const config = { responseType: 'json' }

			if (isDownload) {
				config.responseType = 'blob'
			}

			response = await axios.post(url, payload, config)
		}

		const { data } = response

		if (data) {
			return {
				data: data,
				status: (data.status === 200 ||
							data.status === 204)
			}
		}

		return false
	} catch ({ response }) {
		const { data } = response
		if (data) {
			return {
				status: false,
				data: data
			}
		}
	}
}

export default api
